import React, { FC, ReactNode } from "react";
import styled from "styled-components";

const ButtonTeleconsultationWrapper = styled.div<{ enable: boolean }>`
	background: ${props => (props.enable ? props.theme.colors.greenVitat || "#BFE338" : props.theme.colors.lightGrayVitat || "#dcdee7")};
	border-radius: 7px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: normal;
	gap: 7px;
	padding-top: 7px;
	padding-bottom: 7px;
	padding-left: 50px;
	padding-right: 50px;
	color: ${props => (props.enable ? props.theme.colors.whiteVitat || "#212121" : props.theme.colors.brownVitat || "#8D8D8D")}
`;

interface ButtonTeleconsultationProps {
	handleClick: () => void;
	label?: string;
	icon?: ReactNode;
	enable?: boolean;
}

const ButtonTeleconsultation: FC<ButtonTeleconsultationProps> = ({ icon, label, handleClick, enable = false }) => {
	return (
		<ButtonTeleconsultationWrapper enable={enable} onClick={handleClick}>
			{icon}
			{label}
		</ButtonTeleconsultationWrapper>
	);
};

export default ButtonTeleconsultation;
